module.exports = __webpack_public_path__ + "media/train-blip-02.d0269b44.mp3";